export const INIT_PRODUCT_SEARCH = 'product.INIT_PRODUCT_SEARCH';